import getBasePath from '@/common/functions/api-resource';

const basePath = getBasePath('api', 'role');

const roleActions = {
  gravar: { method: 'POST', url: `${basePath}` },
  atualizar: { method: 'PUT', url: `${basePath}` },
  pesquisar: { method: 'GET', url: `${basePath}?tamanhoPagina={size}&numeroPagina={page}` },
  listar: { method: 'GET', url: `${basePath}/listar` },
  listarRolesPerfilLogado: { method: 'GET', url: `${basePath}/listar-roles-perfil-logado` },
  buscar: { method: 'GET', url: `${basePath}/{codigo}` },
};

export default (resource) => resource(`${basePath}`, {}, roleActions);
